// extracted by mini-css-extract-plugin
module.exports = {"container":"PtdM54pOWgWe308NaGXhL","heading":"_2XaZn2fAEX2634r2uVUUrF","card":"Pl2fVzyWc2EoeqZ3XGOw1","info":"cBYLDmkwyKDUlR_CNxm7w","contact":"FdNJ8rKg8GD2FFRz1xYX3"};